import React from "react";
import PropTypes from "prop-types";

import Title from "./Title";
import Content from "./Content";
import Actions from "./Actions";

const Editor = ({ pageElement, onPageElementChange, passes, onSubmit, onClose }) => {
  return (
    <>
      <Title
        pageElementId={pageElement?.id}
        pageElementType={pageElement?.element_type}
        onClose={onClose}
      />

      <Content
        pageElement={pageElement}
        onPageElementChange={onPageElementChange}
        passes={passes}
      />

      <Actions
        onSubmit={onSubmit}
        pageElementId={pageElement?.id}
        onClose={onClose}
      />
    </>
  );
};

Editor.propTypes = {
  pageElement: PropTypes.object.isRequired,
  onPageElementChange: PropTypes.func.isRequired,
  passes: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default Editor;
